import { useI18nLocale as useGenericI18nLocale } from "@braze/i18n-core";
import type { AllowedLocales } from "../../locales";

export const useI18nLocale: () => AllowedLocales = useGenericI18nLocale as () => AllowedLocales;
